import { useState, useEffect } from "react";
import { Play } from "lucide-react";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Platform", href: "#platform" },
  { label: "Contact", href: "#contact" },
];

const Navbar = ({ onReplay }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-canvas/70 backdrop-blur-md border-line" : "bg-transparent border-transparent"
      }`}
    >
      <div className="flex items-center justify-between gap-3 px-4 sm:px-12 py-4 sm:py-5">
        <a href="#top" data-testid="nav-logo" className="font-display font-bold text-lg sm:text-xl tracking-tight shrink-0">
          adulis<span className="text-clay">.io</span>
        </a>
        <nav className="hidden sm:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-underline text-xs uppercase tracking-[0.2em] font-semibold text-ink-dim hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          <button
            data-testid="replay-video-btn"
            onClick={onReplay}
            className="flex items-center gap-2 whitespace-nowrap border border-line rounded-full px-3.5 sm:px-5 py-2 sm:py-2.5 text-[11px] sm:text-xs uppercase tracking-[0.15em] font-semibold text-ink-dim hover:text-canvas hover:bg-gold hover:border-gold transition-colors duration-300"
            aria-label="Play intro video again"
          >
            <Play size={13} /> <span className="hidden sm:inline">Play video</span><span className="sm:hidden">Play</span>
          </button>
          <a href="#contact" data-testid="nav-cta" className="btn-pill !px-4 sm:!px-6 !py-2 sm:!py-2.5 !text-[11px] sm:!text-xs">
            Join us
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
